export function init() {
	const items = document.querySelectorAll('input[name*="_clone"]');

	items.forEach(input => {
		const clone = document.querySelector(`input[name="${input.name.replace('_clone', '')}"][value="${input.value}"]`);
		if (clone) {
			clone.addEventListener('change', () => {
				input.checked = clone.checked;
				input.dispatchEvent(new CustomEvent("updateResults"));
			})

			input.addEventListener('change', () => {
				clone.checked = input.checked;
				clone.dispatchEvent(new CustomEvent("updateResults"));
			})
		}
	})
}